import app from 'app';
import ready from 'utils/ready';

import blogPage from './blog/main';

app.add({
  blogPage,
});

ready(app.mount);
